import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ICohort, IProfile, IResponse } from "@interfaces/index";
import { AppService } from '@ui-components/services';
import { CohortService } from "../../services/cohort.service";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ICreate } from 'projects/ui-components/src/interfaces/ICohort';


@Component({
    selector: 'app-cohort-modal',
    templateUrl: './cohort-modal.component.html',
    styleUrl: './cohort-modal.component.scss'
  })
export class CohortModalComponent {

  form: FormGroup
  name: ICreate | null = null;
  loading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ICreate,
    protected _app_service: AppService,
    protected _cohort_service: CohortService,
    protected _fb: FormBuilder,
    protected _dialog_ref: MatDialogRef<CohortModalComponent>
  ) {
    this.form = this._fb.group({
      name: [null]
    })
  }

  create() {
    this._cohort_service.createCohort(this.form.get('name')?.value).subscribe(
      (response: IResponse<ICreate>) => {
        this._dialog_ref.close(response.data);
      }
    )
  }

}